// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Products from '../components/Products';
import {actions as ProductsActions} from '../duck';
import {actions as CategoryActions} from '../../categories/duck';
import {actions as InformationActions} from '../../information/duck';

import type {RootState} from '../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    user: state.auth.user,
    products: state.products.products,
    product: state.products.product,
    featuredProducts: state.products.featuredProducts,
    isFetchingFeatured: state.products.isFetchingFeatured,
    pagination: state.products.pagination,
    queryFilter: state.products.queryFilter,
    isFetching: state.products.isFetching,
    isSaving: state.products.isSaving,
    dueInformation: state.tiersList.dueInformation,
    // productOperationError:
    //   state.products.fetchProductsError ||
    //   state.products.saveProductError ||
    //   state.products.createProductError ||
    //   state.products.deleteProductError ||
    //   state.products.editProductError,
    createProductSuccess: state.products.createProductSuccess,
    editProductSuccess: state.products.editProductSuccess,
    deleteProductSuccess: state.products.deleteProductSuccess,
    fetchFeaturedProductsError: state.products.fetchFeaturedProductsError,
    store: state.store.store,
    currency: state.currency.currency,
    catalogue: state.products.catalogue,
    isCreatingCatalogue: state.products.isCreatingCatalogue,
    createCatalogueSuccess: state.products.createCatalogueSuccess,
    createCatalogueError: state.products.createCatalogueError,
    storeInformation: state.ui.storeInformation,
    resellerInformation: state.ui.resellerInformation,
    categories: state.categories.categories,
    isSavingCategory: state.categories.isSaving,
    enableProductSuccess: state.products.enableProductSuccess,
    disableProductSuccess: state.products.disableProductSuccess,
    productFeaturedSuccess: state.products.productFeaturedSuccess,
    productUnfeaturedSuccess: state.products.productUnfeaturedSuccess,
    stockChangeSuccess: state.products.stockChangeSuccess,
    enableProductError: state.products.enableProductError,
    createCategorySuccess: state.categories.createCategorySuccess,
    createCategoryError: state.categories.createCategoryError,
    editCategorySuccess: state.categories.editCategorySuccess,
    editCategoryError: state.categories.editCategoryError,
    deleteCategorySuccess: state.categories.deleteCategorySuccess,
    sortCategoriesSuccess: state.categories.sortCategoriesSuccess,
    sortCategoriesError: state.categories.sortCategoriesError,
    scheduleShipment: state.information.scheduleShipment,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators(
      {
        ...ProductsActions,
        ...CategoryActions,
        ...InformationActions,
        resetCategoryState: CategoryActions.resetState,
        resetProductState: ProductsActions.resetProductState,
      },
      dispatch
    )
)(Products);
